export const lime = {
  lime0: '#f4fff0',
  lime1: '#fcfdfa',
  lime2: '#f8faf3',
  lime3: '#eef6d6',
  lime4: '#e2f0bd',
  lime5: '#d3e7a6',
  lime6: '#c2da91',
  lime7: '#abc978',
  lime8: '#8db654',
  lime9: '#bdee63',
  lime10: '#b0e64c',
  lime11: '#5c7c2f',
  lime12: '#37401c',
};

export const limeA = {
  limeA1: '#66990005',
  limeA2: '#6b95000c',
  limeA3: '#96c80029',
  limeA4: '#8fc60042',
  limeA5: '#81bb0059',
  limeA6: '#72aa006e',
  limeA7: '#61990087',
  limeA8: '#559200ab',
  limeA9: '#93e4009c',
  limeA10: '#8fdc00b3',
  limeA11: '#375f00d0',
  limeA12: '#1e2900e3',
};

export const limeP3 = {
  lime1: 'color(display-p3 0.989 0.992 0.981)',
  lime2: 'color(display-p3 0.975 0.98 0.954)',
  lime3: 'color(display-p3 0.939 0.965 0.851)',
  lime4: 'color(display-p3 0.896 0.94 0.76)',
  lime5: 'color(display-p3 0.843 0.903 0.678)',
  lime6: 'color(display-p3 0.778 0.852 0.599)',
  lime7: 'color(display-p3 0.694 0.784 0.508)',
  lime8: 'color(display-p3 0.585 0.707 0.378)',
  lime9: 'color(display-p3 0.78 0.928 0.466)',
  lime10: 'color(display-p3 0.734 0.896 0.397)',
  lime11: 'color(display-p3 0.386 0.482 0.227)',
  lime12: 'color(display-p3 0.222 0.25 0.128)',
};

export const limeP3A = {
  limeA1: 'color(display-p3 0.412 0.608 0.02 / 0.02)',
  limeA2: 'color(display-p3 0.514 0.592 0.024 / 0.048)',
  limeA3: 'color(display-p3 0.584 0.765 0.008 / 0.15)',
  limeA4: 'color(display-p3 0.561 0.757 0.004 / 0.24)',
  limeA5: 'color(display-p3 0.514 0.698 0.004 / 0.322)',
  limeA6: 'color(display-p3 0.443 0.627 0 / 0.4)',
  limeA7: 'color(display-p3 0.376 0.561 0.004 / 0.491)',
  limeA8: 'color(display-p3 0.333 0.529 0 / 0.624)',
  limeA9: 'color(display-p3 0.588 0.867 0 / 0.534)',
  limeA10: 'color(display-p3 0.561 0.827 0 / 0.604)',
  limeA11: 'color(display-p3 0.386 0.482 0.227)',
  limeA12: 'color(display-p3 0.222 0.25 0.128)',
};
